import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceApiService {
  module = 'invoice'
  constructor(private http: HttpClient) { }

  getList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`${this.module}/getList/${lasyP}`));
  }
  getDetails(id: any) {
    console.log('sd', id);
    return lastValueFrom(this.http.get(`${this.module}/getById/${id}`));
  }

  deleteInvoiceById(id: any, data: any) {
    return lastValueFrom(this.http.post(`${this.module}/delete/${id}`, data));
  }

  saveInvoice(data: any) {
    console.log('data', data);
    return lastValueFrom(this.http.post(`${this.module}/save`, data));
  }
  invoiceDetails() {
    return lastValueFrom(this.http.get(`patient_treatment/getInvoicePendingList/invoicePendingLIst`))
  }
  treatmentGetDetails(id: any) {
    return lastValueFrom(this.http.get(`patient/getTreatment/${id}`));
  }
  invoiceGetDetails(id: any) {
    return lastValueFrom(this.http.get(`payment/getByInvoice/${id}`));
  }
  paymentPendingDetails(id: any) {
    return lastValueFrom(this.http.get(`patient_treatment/getInvoiceGenByPatient/${id}`));
  }

}
